/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Deload_NoteInputs */

const en_us2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This time it's fewer sets at the same weight. It's planned, not a step back: after a cycle of progression, your body recovers and locks in what it gained. Normal volume comes back the workout after.`)
};

const pt_br2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desta vez são menos séries, com a mesma carga. É planejado, não é regressão: depois de um ciclo de progressão, o corpo recupera e consolida o que ganhou. O volume normal volta no treino seguinte.`)
};

const es_419_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta vez son menos series con el mismo peso. Está planeado, no es un retroceso: después de un ciclo de progresión, tu cuerpo se recupera y consolida lo que ganó. El volumen normal vuelve en el entrenamiento siguiente.`)
};

const pt_pt2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desta vez são menos séries, com a mesma carga. É planeado, não é um retrocesso: depois de um ciclo de progressão, o corpo recupera e consolida o que ganhou. O volume normal volta no treino seguinte.`)
};

const fr_fr2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette fois, moins de séries à la même charge. C'est prévu, pas un recul : après un cycle de progression, ton corps récupère et consolide ses acquis. Le volume normal revient à la séance suivante.`)
};

const de_de2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesmal sind es weniger Sätze bei gleichem Gewicht. Das ist geplant, kein Rückschritt: Nach einem Progressionszyklus erholt sich dein Körper und festigt, was er gewonnen hat. Ab dem nächsten Training kommt das normale Volumen zurück.`)
};

const it_it2_plan_deload_note = /** @type {(inputs: Plan_Deload_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa volta sono meno serie con lo stesso carico. È previsto, non è un passo indietro: dopo un ciclo di progressione, il corpo recupera e consolida quello che ha guadagnato. Il volume normale torna dall'allenamento successivo.`)
};

/**
* | output |
* | --- |
* | "This time it's fewer sets at the same weight. It's planned, not a step back: after a cycle of progression, your body recovers and locks in what it gained. No..." |
*
* @param {Plan_Deload_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_deload_note = /** @type {((inputs?: Plan_Deload_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Deload_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_deload_note(inputs)
	if (locale === "es-419") return es_419_plan_deload_note(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_deload_note(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_deload_note(inputs)
	if (locale === "de-DE") return de_de2_plan_deload_note(inputs)
	if (locale === "it-IT") return it_it2_plan_deload_note(inputs)
	return en_us2_plan_deload_note(inputs)
});
export { plan_deload_note as "plan.deload.note" }